import React, { useState, useEffect } from "react";
import { Link } from "gatsby";

import SiteLogo from "../assets/images/hsd-logo.svg";

const Header = ({ siteTitle }) => {
  const [y, setY] = useState(0);
  const [windowHeight, setWindowHeight] = useState(0);
  const [isSideBarMenuOpen, setIsSideBarMenuOpen] = useState(false);
  const [subMenuActive, setSubMenuActive] = useState(false);

  useEffect(() => {
    if (windowHeight === 0) setWindowHeight(window.innerHeight);
    window.addEventListener("scroll", e => {
      setY(window.scrollY);
    });

    // Set cookie for UTM parameters
    const urlParams = new URLSearchParams(window.location.search);
    const utmKeys = {
      utm_source: "utm source",
      utm_id: "utm id",
      utm_medium: "utm medium",
      utm_campaign: "utm campaign",
      utm_term: "utm term",
      utm_content: "utm content",
    };

    let hasUTMParameters = false;
    Object.entries(utmKeys).forEach(([key, val]) => {
      if (urlParams.get(key)) hasUTMParameters = true;
    });

    if (hasUTMParameters) {
      Object.entries(utmKeys).forEach(([key, val]) => {
        const date = new Date();
        date.setTime(date.getTime() + 24 * 60 * 60 * 1000);
        const expires = "expires=" + date.toUTCString();
        document.cookie = `visitor_${key}=${
          urlParams.get(key) || "-"
        }; ${expires}; path=/`;
      });
    }
  }, [y]);

  const openSideBarMenu = () => {
    setSubMenuActive([]);
    setIsSideBarMenuOpen(true);
  };

  const closeSideBarMenu = () => {
    setSubMenuActive([]);
    setIsSideBarMenuOpen(false);
  };

  const openSubMenu = menuNumber => {
    if (subMenuActive === menuNumber) setSubMenuActive([]);
    else setSubMenuActive(menuNumber);
  };

  return (
    <>
      <header
        className={
          y > windowHeight ? "main-header main-header-sticky" : "main-header"
        }
      >
        <div className="main-header-container">
          <div className="site-logo">
            <Link className="main-logo" to="/">
              <img src={SiteLogo} alt={siteTitle} />
            </Link>
          </div>
          <div className="header-nav">
            <ul>
              <li>
                <span className="nav-item nav-item-parent">Professions</span>
                <ul className="sub-menu">
                  <li className="subnav-item">
                    <Link className="nav-item" to="/audiences/specialists/">
                      Specialists
                    </Link>
                  </li>
                  <li className="subnav-item">
                    <Link className="nav-item" to="/audiences/gps/">
                      GPs
                    </Link>
                  </li>
                  <li className="subnav-item">
                    <Link className="nav-item" to="/audiences/dental/">
                      Dental
                    </Link>
                  </li>
                  <li className="subnav-item">
                    <Link className="nav-item" to="/audiences/optometrists/">
                      Optometrists
                    </Link>
                  </li>
                  <li className="subnav-item">
                    <Link className="nav-item" to="/audiences/government/">
                      Government & Not-for-Profit
                    </Link>
                  </li>
                  <li className="subnav-item">
                    <Link className="nav-item" to="/audiences/phis/">
                      Private Health Insurers
                    </Link>
                  </li>
                  <li className="subnav-item">
                    <Link className="nav-item" to="/audiences/pharmaceutical/">
                      Pharmaceutical
                    </Link>
                  </li>
                </ul>
              </li>
              <li>
                <span className="nav-item nav-item-parent">Solutions</span>
                <ul className="sub-menu">
                  <li className="subnav-item">
                    <Link className="nav-item" to="/solutions/referrals/">
                      Specialist Referrals Directory
                    </Link>
                  </li>
                  <li className="subnav-item">
                    <Link className="nav-item" to="/solutions/betterconsult/">
                      BetterConsult
                    </Link>
                  </li>
                  <li className="subnav-item">
                    <Link className="nav-item" to="/solutions/factsheets/">
                      FactSheets
                    </Link>
                  </li>
                </ul>
              </li>
              <li>
                <Link className="nav-item" to="/blog/">
                  News
                </Link>
              </li>
              <li>
                <span className="nav-item nav-item-parent">About Us</span>
                <ul className="sub-menu">
                  <li className="subnav-item">
                    <Link className="nav-item" to="/company/about/">
                      Who We Are
                    </Link>
                  </li>
                  <li className="subnav-item">
                    <Link className="nav-item" to="/company/leadership/">
                      Meet the Team
                    </Link>
                  </li>
                  <li className="subnav-item">
                    <Link className="nav-item" to="/company/careers/">
                      Careers
                    </Link>
                  </li>
                </ul>
              </li>
              <li>
                <Link className="nav-item" to="/contact/">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </header>
      <header
        className={
          y > windowHeight
            ? "main-header-mobile main-header-mobile-sticky"
            : "main-header-mobile"
        }
      >
        <div className="main-header-container">
          <div className="site-logo">
            <Link className="main-logo" to="/">
              <img src={SiteLogo} alt={siteTitle} />
            </Link>
          </div>
          <div
            onClick={openSideBarMenu}
            className={isSideBarMenuOpen ? "cta-burger opened" : "cta-burger"}
          >
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </header>
      <div
        className={isSideBarMenuOpen ? "sidebar-menu active" : "sidebar-menu"}
      >
        <div className="sidebar-menu-overlay"></div>
        <div className="sidebar-menu-body">
          <div className="site-logo">
            <Link className="main-logo" to="/" onClick={closeSideBarMenu}>
              <img src={SiteLogo} alt={siteTitle} />
            </Link>
          </div>
          <i
            className="cta-sidebar-close fas fa-arrow-right"
            onClick={closeSideBarMenu}
          ></i>
          <div className="sidebar-menu-list">
            <ul>
              <li>
                <span
                  className="nav-item nav-item-parent"
                  onClick={() => {
                    openSubMenu(1);
                  }}
                >
                  Professions
                </span>
                <ul
                  className={
                    subMenuActive === 1 ? "sub-menu active" : "sub-menu"
                  }
                >
                  <li className="subnav-item">
                    <Link
                      className="nav-item"
                      to="/audiences/specialists/"
                      onClick={closeSideBarMenu}
                    >
                      Specialists
                    </Link>
                  </li>
                  <li className="subnav-item">
                    <Link
                      className="nav-item"
                      to="/audiences/gps/"
                      onClick={closeSideBarMenu}
                    >
                      GPs
                    </Link>
                  </li>
                  <li className="subnav-item">
                    <Link
                      className="nav-item"
                      to="/audiences/dental/"
                      onClick={closeSideBarMenu}
                    >
                      Dental
                    </Link>
                  </li>
                  <li className="subnav-item">
                    <Link
                      className="nav-item"
                      to="/audiences/optometrists/"
                      onClick={closeSideBarMenu}
                    >
                      Optometrists
                    </Link>
                  </li>
                  <li className="subnav-item">
                    <Link
                      className="nav-item"
                      to="/audiences/government/"
                      onClick={closeSideBarMenu}
                    >
                      Government & Not-for-Profit
                    </Link>
                  </li>
                  <li className="subnav-item">
                    <Link
                      className="nav-item"
                      to="/audiences/phis/"
                      onClick={closeSideBarMenu}
                    >
                      Private Health Insurers
                    </Link>
                  </li>
                  <li className="subnav-item">
                    <Link
                      className="nav-item"
                      to="/audiences/pharmaceutical/"
                      onClick={closeSideBarMenu}
                    >
                      Pharmaceutical
                    </Link>
                  </li>
                </ul>
              </li>
              <li>
                <span
                  className="nav-item nav-item-parent"
                  onClick={() => {
                    openSubMenu(2);
                  }}
                >
                  Solutions
                </span>
                <ul
                  className={
                    subMenuActive === 2 ? "sub-menu active" : "sub-menu"
                  }
                >
                  <li className="subnav-item">
                    <Link
                      className="nav-item"
                      to="/solutions/referrals/"
                      onClick={closeSideBarMenu}
                    >
                      Specialist Referrals Directory
                    </Link>
                  </li>
                  <li className="subnav-item">
                    <Link
                      className="nav-item"
                      to="/solutions/betterconsult/"
                      onClick={closeSideBarMenu}
                    >
                      BetterConsult
                    </Link>
                  </li>
                  <li className="subnav-item">
                    <Link
                      className="nav-item"
                      to="/solutions/factsheets/"
                      onClick={closeSideBarMenu}
                    >
                      FactSheets
                    </Link>
                  </li>
                </ul>
              </li>
              <li>
                <Link
                  className="nav-item"
                  to="/blog/"
                  onClick={closeSideBarMenu}
                >
                  News
                </Link>
              </li>
              <li>
                <span
                  className="nav-item nav-item-parent"
                  onClick={() => {
                    openSubMenu(3);
                  }}
                >
                  About Us
                </span>
                <ul
                  className={
                    subMenuActive === 3 ? "sub-menu active" : "sub-menu"
                  }
                >
                  <li className="subnav-item">
                    <Link
                      className="nav-item"
                      to="/company/about/"
                      onClick={closeSideBarMenu}
                    >
                      Who We Are
                    </Link>
                  </li>
                  <li className="subnav-item">
                    <Link
                      className="nav-item"
                      to="/company/leadership/"
                      onClick={closeSideBarMenu}
                    >
                      Meet the Team
                    </Link>
                  </li>
                  <li className="subnav-item">
                    <Link
                      className="nav-item"
                      to="/company/careers/"
                      onClick={closeSideBarMenu}
                    >
                      Careers
                    </Link>
                  </li>
                </ul>
              </li>
              <li>
                <Link
                  className="nav-item"
                  to="/contact/"
                  onClick={closeSideBarMenu}
                >
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
